import server from "../../../../server";

export async function deleteDocument(id: string) {
    await server.document.delete(id);
}

export async function deletePolicy(policyId: string) {
    await server.policy.delete(policyId);
}

export async function publishPolicy(policyId: string) {
    await server.policy.update(policyId, "PUBLISHED")
}

export async function getPolicies(status: string) {
    await server.policy.search(0, 0, status);
}